interface PremiumSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Modal that shows success message when premium user returns from payment
 */
export function PremiumSuccessModal({
  isOpen,
  onClose,
}: PremiumSuccessModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl shadow-2xl p-8 max-w-md w-full border border-gray-700">
        <div className="text-center">
          {/* Success icon */}
          <div className="mb-6 flex justify-center">
            <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center">
              <svg
                className="w-12 h-12 text-white"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-white mb-3">
            You're Premium! 🎉
          </h2>

          {/* Message */}
          <p className="text-gray-300 mb-6">
            Your payment has been processed successfully. You now have access to all premium benefits:
          </p>

          {/* Benefits list */}
          <div className="text-left bg-gray-800/50 rounded-lg p-4 mb-6 space-y-2">
            <div className="flex items-start gap-2">
              <span className="text-green-500 mt-0.5">✓</span>
              <span className="text-gray-300 text-sm">Unlimited file transfers</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-green-500 mt-0.5">✓</span>
              <span className="text-gray-300 text-sm">No file size limits</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-green-500 mt-0.5">✓</span>
              <span className="text-gray-300 text-sm">Priority support</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-green-500 mt-0.5">✓</span>
              <span className="text-gray-300 text-sm">All future premium features</span>
            </div>
          </div>

          {/* Close button */}
          <button
            onClick={onClose}
            className="w-full px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white rounded-lg font-medium transition-all shadow-lg"
          >
            Start Using Premium
          </button>
        </div>
      </div>
    </div>
  );
}
